import styled from '@emotion/styled/macro'
import { Flex } from '@rebass/grid/emotion'
import { FlexSpinner, GlobalMessage } from 'components'
import { useAuthContext } from 'hooks/useAuthContext'
import { UserRole } from 'model'
import { Fabric } from 'office-ui-fabric-react'
import * as React from 'react'
import { AppBar, AppBarProps } from '../AppBar'
import { AppCommandBarProps } from '../AppCommandBar'
import { AppNavigation, AppNavigationProps } from '../AppNavigation'
import { AppNavigationDrawer } from '../AppNavigationDrawer'
import { appBarHeight } from '../constants'
import { GlobalStyles } from '../GlobalStyles'

const Root = styled(Flex)`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`
const Main = styled.div`
  height: calc(100% - ${appBarHeight}px);
  overflow: hidden;
`
const ContentContainer = styled.div`
  flex: 1 0;
  overflow-y: scroll;
`

export interface AppShellProps {
  appBar?: React.ReactNode
  appBarProps?: AppBarProps
  appNavigation?: React.ReactNode
  appNavigationProps?: AppNavigationProps
  appCommandBar?: React.ReactNode
  appCommandBarProps?: AppCommandBarProps
  roles: UserRole[]
}

export const AppShell: React.FunctionComponent<AppShellProps> = ({
  appBar: maybeAppBar,
  appBarProps,
  appNavigation: maybeAppNavigation,
  appNavigationProps,
  appCommandBar: maybeAppCommandBar,
  appCommandBarProps,
  children,
  roles,
}) => {
  const auth = useAuthContext()
  const isAuthorized = auth.hasUserRole(roles)
  const appBar = maybeAppBar ? maybeAppBar : <AppBar {...appBarProps} />
  const appNavigation = maybeAppNavigation ? (
    maybeAppNavigation
  ) : (
    <AppNavigation {...appNavigationProps} />
  )
  // const appCommandBar = maybeAppCommandBar ? (
  //   maybeAppCommandBar
  // ) : (
  //   <AppCommandBar hideWhenEmpty={true} items={[]} {...appCommandBarProps} />
  // )

  return isAuthorized ? (
    <Fabric>
      <Root flexDirection="column">
        <GlobalStyles />
        {appBar}
        <Main>
          <AppNavigationDrawer appNavigation={appNavigation}>
            <Flex flexDirection="column" flex={1}>
              {/* {appCommandBar} */}
              <GlobalMessage />
              <ContentContainer>{children}</ContentContainer>
            </Flex>
          </AppNavigationDrawer>
        </Main>
      </Root>
    </Fabric>
  ) : (
    <FlexSpinner loading={!isAuthorized} label="EMOS wird geladen..." />
  )
}

export default AppShell
